<template>
  <div class="app-root">
    <nuxt />
    <tabbar />
    <client-only>
        <portal-target multiple name="authModal"></portal-target>
    </client-only>
  </div>
</template>

<script>
import tabbar from '../components/tabbar.vue';

export default {
    components: {
        tabbar,
    },
};
</script>

<style lang="scss">
    .app-root {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>

